import { StoreEnhancerStoreCreator, Reducer, Unsubscribe, AnyAction } from 'redux';

/**
 * An action can be
 *  - an object with a type key
 *  - a promise that resolve an action
 *  - a function that return an action
 *  - an array of any of the above
 */
import { obfuscatedSymbol } from './symbol';

export type ActionObject = AnyAction;

export type ActionPromise<S, C> = Promise<Dispatchable<S, C> | ActionObject | ActionFunction<S, C>>;

export type ActionFunction<S, C> = (state: S, container: C) => Dispatchable<S, C> | ActionPromise<S, C>;

export type ActionArray<S, C> = Array<ActionObject | ActionPromise<S, C> | ActionFunction<S, C> | Dispatchable<S, C>>;

export type ObfuscatedDispatchable<S, C> = {
  [obfuscatedSymbol]: [S, C];
};

export type Dispatchable<S, C> = ObfuscatedDispatchable<S, C> | ActionFunction<S, C> | ActionObject | null;

export type ValidAction<S, C> =
  | ActionObject
  | ActionPromise<S, C>
  | ActionFunction<S, C>
  | ActionArray<S, C>
  | Dispatchable<S, C>
  | null;

export type GetState<S> = () => S;

// export type Dispatch<A extends Dispatchable = Dispatchable> = (actions: A) => Promise<void>;
// action are not typed to make it work with React Redux connect
export type Dispatch = (actions: any) => Promise<void>;

export type ReduxCompatibleDispatch = (actions: any) => Promise<void>;

export type Stabilizer<S, C> = (state: S, container: C) => Dispatchable<S, C>;
export type Stabilizers<S, C> = Array<Stabilizer<S, C>>;

export interface ReduxStabilizerStore<S, C> {
  dispatch: Dispatch;
  replaceStabilizers(nextStabilizers: Stabilizers<S, C>): void;
  replaceReducer(nextReducer: Reducer<S>): void;
  getState(): S;
  subscribe(listener: () => void): Unsubscribe;
}

export type StoreEnhancer<S, C> = (
  next: StoreEnhancerStoreCreator<S>
) => StoreEnhancerReduxStabilizerStoreCreator<S, C>;
export type StoreEnhancerReduxStabilizerStoreCreator<S, C> = (
  reducer: Reducer<S>,
  preloadedState: S
) => ReduxStabilizerStore<S, C>;



// WEBPACK FOOTER //
// ./src/lib/redux-stabilizer/types.ts